// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_rattan_lattice/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_rattan_lattice: ModuleSchema = {
  "id": "core_rattan_lattice",
  "uniqueId": "B3D_RAT01",
  "createdAt": "2026-10-11T07:00:00Z",
  "updatedAt": "2026-10-16T14:18:38.614Z",
  "label": "Woven Rattan Cluster",
  "description": "A compact 2x2 cluster of four square sinusoidally woven rattan blocks.",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_RAT01",
    "rattan-weave",
    "sinuous-wicker",
    "cluster"
  ],
  "sliders": [
    {
      "key": "baseDiameter",
      "label": "Block Width/Depth (mm)",
      "min": 40,
      "max": 150,
      "default": 130,
      "step": 2,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "height",
      "label": "Block Height (mm)",
      "min": 10,
      "max": 120,
      "default": 40,
      "step": 2,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "strandThickness",
      "label": "Strand Thickness (Radial, mm)",
      "min": 0.4,
      "max": 2.5,
      "default": 0.84,
      "step": 0.02,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "strandHeight",
      "label": "Strand Height (Z, mm)",
      "min": 1,
      "max": 5,
      "default": 2,
      "step": 0.1,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "wavePitch",
      "label": "Wave Peak Pitch (mm)",
      "min": 1.5,
      "max": 12,
      "default": 4,
      "step": 0.1,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "waveAmplitude",
      "label": "Wave Amplitude (mm)",
      "min": 0.4,
      "max": 4,
      "default": 1.5,
      "step": 0.1,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "layerOverlap",
      "label": "Layer Overlap (Z, mm)",
      "min": 0,
      "max": 1,
      "default": 0.3,
      "step": 0.05,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "bellyRadius",
      "label": "Belly Radius (mm, max H/2)",
      "min": 0.5,
      "max": 40,
      "default": 13,
      "step": 0.5,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "rattan_color",
      "label": "Màu Nan Mây (Rattan Color)",
      "default": "#D97706",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1,
        2,
        3
      ]
    }
  ],
  "objects": [
    {
      "id": "rattan_weave",
      "name": "Cluster Block 1",
      "parts": [
        {
          "id": "weave_body",
          "name": "Woven Rattan Block 1",
          "groupId": 0,
          "colorKey": "rattan_color",
          "defaultColor": "#D97706",
          "previewQuality": "medium",
          "exportQuality": "high",
          "visible": true
        }
      ]
    },
    {
      "id": "rattan_square_form_object",
      "name": "Cluster Block 2",
      "parts": [
        {
          "id": "rattan_square_form",
          "name": "Woven Rattan Block 2",
          "groupId": 1,
          "colorKey": "rattan_color",
          "defaultColor": "#D97706",
          "previewQuality": "medium",
          "exportQuality": "high",
          "visible": true
        }
      ]
    },
    {
      "id": "rattan_pillow_form_object",
      "name": "Cluster Block 3",
      "parts": [
        {
          "id": "rattan_pillow_form",
          "name": "Woven Rattan Block 3",
          "groupId": 2,
          "colorKey": "rattan_color",
          "defaultColor": "#D97706",
          "previewQuality": "medium",
          "exportQuality": "high",
          "visible": true
        }
      ]
    },
    {
      "id": "rattan_waves_tier_object",
      "name": "Cluster Block 4",
      "parts": [
        {
          "id": "rattan_waves_tier_form",
          "name": "Woven Rattan Block 4",
          "groupId": 3,
          "colorKey": "rattan_color",
          "defaultColor": "#D97706",
          "previewQuality": "medium",
          "exportQuality": "high",
          "visible": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Rattan Weave"
    }
  ]
};
